import $ from 'jquery';
import { getUser } from '~src/user';

function toggleSidebarProfile() {
  $('#sidebar-profile').toggleClass('sidebar-profile-open');
}

const sidebarOrgData = async () => {
  let html = `
  <ul>
    <a href="/projects" data-navigo class="text-light font-weight-bold"><li>Progetti</li></a>
    <a href="${process.env.ETERNO_URL}/index.php?page=defunto" target="_blank" class="text-light font-weight-bold"><li>Servizi</li></a>
    <a href="/subscription" data-navigo class="text-light font-weight-bold"><li>Abbonamento</li></a>
    <a href="/credits" data-navigo class="text-light font-weight-bold"><li>Crediti IA</li></a>
  </ul>`;

  $('#sidebar-profile-body').html(html);
};

const refreshProfile = async () => {
  $('#sidebar-profile-refresh-loader')
    .removeClass('d-none')
    .addClass('d-block');
  $('#sidebar-profile-refresh-icon').removeClass('d-block').addClass('d-none');
  await getUser({}, true);
  $('#sidebar-profile-refresh-loader')
    .addClass('d-none')
    .removeClass('d-block');
  $('#sidebar-profile-refresh-icon').addClass('d-block').removeClass('d-none');
};

export function initSidebarProfile() {
  $('body').off('click', '.openSidebarProfile');
  $('body').on('click', '.openSidebarProfile', toggleSidebarProfile);
  $('body').on('click', '#sidebar-profile-refresh', refreshProfile);
  sidebarOrgData();
}
